'use client';
import React, { useEffect, useState } from 'react';
import Link from 'next/link';

export default function StickyCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 1);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`sticky-cta fixed bottom-0 left-0 right-0 z-40 ${visible ? 'visible' : ''}`}
      aria-hidden={!visible}
    >
      <div className="bg-canopy/95 backdrop-blur-xl border-t border-chartreuse/20 px-6 py-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-2 h-2 rounded-full bg-chartreuse animate-pulse shrink-0" />
            <span className="font-mono text-sm text-text-muted">
              <span className="text-chartreuse font-bold">Agro Teknologi Nusantara</span> · Solusi Pertanian Modern & Smart Farming
            </span>
          </div>
          <div className="flex items-center gap-4 shrink-0">
            <a
              href="https://wa.me/6281253837777?text=Halo%20Agro Teknologi Nusantara,%20saya%20tertarik%20dengan%20layanan"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline-chartreuse px-5 py-2.5 rounded-sm text-xs uppercase tracking-widest"
            >
              WhatsApp
            </a>
            <Link
              href="/quote"
              className="btn-chartreuse px-6 py-2.5 rounded-sm text-xs uppercase tracking-widest"
            >
              Hubungi Kami →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
